import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FiHome, FiTruck, FiCalendar, FiSettings,
  FiChevronLeft, FiChevronRight
} from 'react-icons/fi';
import { useTenant } from '../../context/TenantContext';

const ManagerSidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const { companyName, companyLogo } = useTenant();
  
  const menuItems = [
    { path: '/manager', label: 'Dashboard', icon: FiHome },
    { path: '/manager/cars', label: 'Cars', icon: FiTruck },
    { path: '/manager/bookings', label: 'Bookings', icon: FiCalendar },
    { path: '/manager/settings', label: 'Company Settings', icon: FiSettings },
  ];
  
  const isActive = (path) => {
    if (path === '/manager') {
      return location.pathname === '/manager';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside 
      className={`fixed left-0 top-0 h-full bg-gray-900 text-white transition-all duration-300 z-40 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-800">
        {!collapsed && (
          <Link to="/manager" className="flex items-center gap-2">
            {companyLogo ? (
              <img src={companyLogo} alt={companyName} className="w-8 h-8 rounded-lg object-cover" />
            ) : (
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">
                  {companyName?.[0] || 'M'}
                </span>
              </div>
            )}
            <span className="font-bold text-lg truncate">{companyName || 'Manager'}</span>
          </Link>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
        >
          {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
      </div>
      
      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${
                active 
                  ? 'bg-primary-600 text-white' 
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`}
              title={collapsed ? item.label : undefined}
            >
              <Icon size={20} />
              {!collapsed && <span className="font-medium">{item.label}</span>}
            </Link>
          );
        })}
      </nav>
      
      {/* Footer */}
      {!collapsed && (
        <div className="absolute bottom-4 left-4 right-4">
          <div className="text-xs text-gray-500 text-center">
            Manager Dashboard
          </div>
        </div>
      )}
    </aside>
  );
};

export default ManagerSidebar;
